import { Injectable } from '@angular/core';
import { Coupon } from '@generated/tcea/models/coupon';
import { Observable } from 'rxjs';

@Injectable()
export abstract class AbstractCouponService {
  abstract get(
    brandId: string,
    params: {
      page?: number;
      query: {
        archived?: boolean;
        availabilityStart?: string;
        availabilityEnd?: string;
        search?: string;
        enabled?: boolean;
        type?: string;
      };
      sort: {
        direction?: string;
        field?: string;
      };
    },
  ): Observable<{ data: Coupon[]; pages: number }>;
  abstract getCouponById(couponId: string, brandId: string): Observable<Coupon>;
  abstract create(brandId: string, createData: any): Observable<Coupon>;
  abstract update(brandId: string, couponId: string, updateData: Coupon): Observable<Coupon>;
}
